import React from 'react';

import { Highlights } from '../highlights';
import { InfoIcons } from '../info-icons';
import { Subheader } from './subheader';
import { Title } from './title';

import * as S from './title-container.styles';

export const TitleContainer: React.FC = () => (
  <S.StyledTitleContainer>
    <Title />
    <Subheader />
    <InfoIcons />
    <Highlights />
  </S.StyledTitleContainer>
);
